<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 19 19"
  >
    <circle
      cx="7.467"
      cy="7.871"
      r="5.107"
      stroke="currentColor"
      stroke-width="2"
    />
    <path stroke="currentColor" stroke-width="2" d="m11.945 11.537 5.7 5.7" />
  </svg>
</template>
